const ONE_ON_ONE_CHAT_MODAL_ID_PREFIX = 'one-on-one-chat-';

/**
 * Ionic modal `id` of the 1-on-1 chat with an office. Every entry point passes it to `modalCtrl.create()`,
 * so `modalCtrl.getTop()` is the single source of truth for "is this chat open" — no open-state in a sandbox.
 */
export function oneOnOneChatModalId(agentExternalId: string): string {
  return `${ONE_ON_ONE_CHAT_MODAL_ID_PREFIX}${agentExternalId}`;
}

export function isOneOnOneChatModalId(id: string | undefined): boolean {
  return !!id?.startsWith(ONE_ON_ONE_CHAT_MODAL_ID_PREFIX);
}
